import fetchHandler from "../../utils/fetchHandler";
import { FITNESS_JOURNAL } from "../types/actions";

export const getFitnessJournalSummary = (queryString) => {
	const fetchOptions = {
		url: `/api/fitness_journals/summary/?${queryString}`,
		method: "GET",
		actionType: FITNESS_JOURNAL.GET_FITNESS_JOURNAL_SUMMARY
	};
	return fetchHandler(fetchOptions);
};

export const createFitnessJournal = (values, successHandler, errorHandler) => {
	const fetchOptions = {
		url: `/api/fitness_journals/`,
		method: "POST",
		actionType: FITNESS_JOURNAL.CREATE_FITNESS_JOURNAL,
		body: JSON.stringify(values)
	};
	return fetchHandler(fetchOptions, successHandler, errorHandler);
};

export const editFitnessJournal = (values, successHandler, errorHandler) => {
	const fetchOptions = {
		url: `/api/fitness_journals/${values.id}`,
		method: "PUT",
		actionType: FITNESS_JOURNAL.EDIT_FITNESS_JOURNAL,
		body: JSON.stringify(values)
	};
	return fetchHandler(fetchOptions, successHandler, errorHandler);
};

export const deleteFitnessJournal = (values, successHandler) => {
	const fetchOptions = {
		url: `/api/fitness_journals/${values.id}`,
		method: "DELETE",
		actionType: FITNESS_JOURNAL.DELETE_FITNESS_JOURNAL,
		body: JSON.stringify(values)
	};
	return fetchHandler(fetchOptions, successHandler);
};

export const getFitnessJournal = () => {
	const fetchOptions = {
		url: `/api/fitness_journals/`,
		method: "GET",
		actionType: FITNESS_JOURNAL.GET_FITNESS_JOURNAL
	};
	return fetchHandler(fetchOptions);
};

export const getFitnessGoals = (queryString) => {
	const fetchOptions = {
		url: `/api/fitness_goals/?${queryString}`,
		method: "GET",
		actionType: FITNESS_JOURNAL.GET_FITNESS_GOALS
	};
	return fetchHandler(fetchOptions);
};

export const saveFitnessGoals = (values, successHandler) => {
	const fetchOptions = {
		url: `/api/fitness_goals/${values.id}`,
		method: "PUT",
		body: JSON.stringify(values),
		actionType: FITNESS_JOURNAL.SAVE_FITNESS_GOALS
	};
	return fetchHandler(fetchOptions, successHandler);
};

export const createFitnessGoals = (values, successHandler) => {
	const fetchOptions = {
		url: `/api/fitness_goals/`,
		method: "POST",
		body: JSON.stringify(values),
		actionType: FITNESS_JOURNAL.CREATE_FITNESS_GOALS
	};
	return fetchHandler(fetchOptions, successHandler);
};
